import { makeVar } from '@apollo/client';
export var userActivitiesDataVar = makeVar({
    loading: false
});
